import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
// const dotenv = require("dotenv");
// dotenv.config({path:'./config.env'})
// var firebaseConfig = {

//   apiKey: process.env.APIKEY,
//   authDomain: process.env.AUTHDOMAIN,
//   databaseURL:process.env.DATABASEURL,
//   projectId: process.env.PROJECTID,
//   storageBucket: process.env.STORAGEBUCKET,
//   appId: process.env.APPID,
// };
var firebaseConfig = {

  apiKey: "AIzaSyCse6U4E0N9KnzPZvpyUch3fIFMSdKs5Y0",
  authDomain: "todo-e2356.firebaseapp.com",
  databaseURL:"https://todo-e2356-default-rtdb.firebaseio.com",
  projectId: "todo-e2356",
  storageBucket: "todo-e2356.appspot.com",
  appId: "1:947869226084:web:5272b4d0ec256b77683b71",
};

firebase.initializeApp(firebaseConfig);
export default firebase
